import { History } from 'history';
import { useHistory } from 'react-router-dom';

function useIsModal() {
  const history: History<{ modal: boolean }> = useHistory();
  const isModal =
    history.location.state?.modal === true && history.action === 'PUSH';

  return isModal;
}

export default useIsModal;
